import { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";

const YoutubeVideoModel = ({ show, close, videoUrl, title }) => {
  const isMobile = window.innerWidth < 768;

  const [isLoading, setIsLoading] = useState(true); // 🔥 add state

  const getEmbedUrl = (url, autoplay = true) => {
    if (!url) return null;

    try {
      const urlObj = new URL(url);

      if (
        !urlObj.hostname.includes("youtube.com") &&
        !urlObj.hostname.includes("youtu.be")
      ) {
        return null;
      }

      const videoId = urlObj.searchParams.get("v");
      const listId = urlObj.searchParams.get("list");

      if (listId) {
        return `https://www.youtube.com/embed/videoseries?list=${listId}${
          autoplay ? "&autoplay=1&mute=1" : ""
        }`;
      }

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}${
          autoplay ? "?autoplay=1&mute=1" : ""
        }`;
      }

      return null;
    } catch {
      return null;
    }
  };

  const embedUrl = getEmbedUrl(videoUrl, !isMobile);

  useEffect(() => {
    if (show) setIsLoading(true);
  }, [show, videoUrl]);

  return (
    <Modal show={show} centered onHide={close} size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "black" }}>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center py-3">
        <div className="video-container ratio ratio-16x9 position-relative">
          {isLoading && (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                position: "absolute",
                inset: 0,
                background: "#00000010",
                zIndex: 1,
              }}
            >
              <Spinner />
            </div>
          )}

          {embedUrl && (
            <iframe
              src={embedUrl}
              title="Planner"
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={{ borderRadius: "12px" }}
              onLoad={() => setIsLoading(false)}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default YoutubeVideoModel;
